import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Label, Spinner } from "../../../../widgets";
import { NameLookupProperties, useNameLookupProperties } from "./NameLookupProperties";

import { DraftLookupNameComponent } from "./DraftLookupNameComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const LookupNameComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useNameLookupProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <Label
        className={className}
        iconClassName="me-1"
        {...properties}>
        {children}
    </Label>
}

Registry.addControl({
    id: "2edd5628-2baa-4e4c-a32b-31d54e8f853e",
    name: "Name Lookup",
    type: ControlType.NameLookup,
    properties: NameLookupProperties,
    component: LookupNameComponent,
    draftComponent: DraftLookupNameComponent
})
